import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LOGIN } from "../../../../redux/actionTypes";

const SsoLanding = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const access_token = params.get("token");
    const userDataStr = params.get("userData");

    if (access_token && userDataStr) {
      try {
        const profile = JSON.parse(userDataStr);

        // Persist to storage (matching saveToStorage in authActions.js)
        localStorage.setItem("token", access_token);
        localStorage.setItem("userData", JSON.stringify(profile));

        // Update Redux state
        dispatch({ type: LOGIN, payload: profile });

        // Redirect to myjobs
        history.replace("/myjobs");
      } catch (error) {
        history.replace("/signin");
      }
    } else {
      history.replace("/signin");
    }
  }, [location, dispatch, history]);

  return (
    <div
      className="w-100 d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <div className="text-center">
        <h3>Authenticating...</h3>
        <p>Please wait while we redirect you.</p>
      </div>
    </div>
  );
};

export default SsoLanding;
